/* Pertegaz — mega menu: open on hover AND click, auto-switch between items on hover.
   (Dawn's mega is a native <details> that opens on click only.) */
(function () {
  function init() {
    var inline = document.querySelector('.header__inline-menu');
    if (!inline) return;
    var menus = Array.prototype.slice.call(inline.querySelectorAll('header-menu'));
    if (!menus.length) return;
    var closeTimer = null;

    function det(m) { return m.querySelector('details.mega-menu'); }

    function openOnly(target) {
      menus.forEach(function (m) {
        var d = det(m);
        if (!d) return;
        var sum = d.querySelector('summary');
        if (m === target) {
          if (!d.hasAttribute('open')) {
            d.setAttribute('open', '');
            if (sum) sum.setAttribute('aria-expanded', 'true');
          }
        } else if (d.hasAttribute('open')) {
          d.removeAttribute('open');
          if (sum) sum.setAttribute('aria-expanded', 'false');
        }
      });
    }
    function closeAll() { openOnly(null); }
    function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
    function scheduleClose() { cancelClose(); closeTimer = setTimeout(closeAll, 140); }

    menus.forEach(function (m) {
      // hover opens this one and switches away from the others
      m.addEventListener('mouseenter', function () { cancelClose(); openOnly(m); });
      var sum = m.querySelector('summary');
      if (sum) {
        // click also opens (never let the native <details> toggle it shut)
        sum.addEventListener('click', function (e) {
          e.preventDefault();
          cancelClose();
          openOnly(m);
        });
      }
    });

    // Keep open while the pointer is anywhere inside the menu or its (DOM-nested) panels;
    // close shortly after it leaves. Small delay bridges the header→panel gap.
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest('.header__inline-menu')) cancelClose();
      else scheduleClose();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
